// Robust client-side email validation utility

const COMMON_EMAIL_DOMAINS = [
  "gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "icloud.com", "aol.com", "protonmail.com", "zoho.com", "mail.com", "gmx.com"
];
const VALID_TLDS = [
  "com", "net", "org", "edu", "gov", "mil", "co", "io", "ai", "us", "ca", "uk", "de", "fr", "jp", "au", "in", "ru", "ch", "it", "nl", "se", "no", "es", "cz", "biz", "info", "me", "tv", "xyz", "dev", "app"
];
const COMMON_DOMAIN_TYPOS = [
  "gamil.com", "gnail.com", "gmal.com", "yaho.com", "hotmial.com", "outlok.com", "icloud.con", "protonmail.con"
];

export function getEmailValidationError(email: string): string {
  if (!email) return "";
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(email)) {
    return "Please enter a valid email address.";
  }
  const domain = email.split("@")[1] || "";
  if (COMMON_DOMAIN_TYPOS.includes(domain)) {
    return "Did you mean gmail.com, yahoo.com, etc.? Please check your email domain.";
  }
  const tld = (domain || '').split(".").pop() || '';
  if (!VALID_TLDS.includes(tld)) {
    return "Please enter an email address with a valid domain (e.g., .com, .org, .net, etc.)";
  }
  if (domain && !COMMON_EMAIL_DOMAINS.includes(domain) && domain.split(".").length < 2) {
    return "Please enter a valid email domain.";
  }
  return "";
} 